(function () {
  var config = window.OASIS_STATE_RESTRICTIONS;
  if (!config || !config.enabled) return;

  var DEFAULT_GEO_URL = 'https://ipapi.co/json/';
  var DEFAULT_STATES = ['CA', 'AK', 'AZ', 'ID', 'IA', 'NE', 'OK', 'OR', 'VA', 'TN'];
  var geoApiUrl = (config.geoApiUrl && String(config.geoApiUrl).trim()) || DEFAULT_GEO_URL;
  var cacheMin = parseInt(config.geoCacheMinutes, 10);
  if (isNaN(cacheMin) || cacheMin < 0) {
    cacheMin = 1440;
  }
  var STORAGE_TTL_MS = cacheMin * 60 * 1000;
  var useGeoCache = STORAGE_TTL_MS > 0;
  var STORAGE_KEY = 'oasis_state_geo_v1';
  var SESSION_SEEN_KEY = 'oasis_state_restrictions_seen_v1';

  var restrictedStates = normalizeStates(config.stateCodes || config.states || DEFAULT_STATES);

  var modal = document.getElementById('StateRestrictionsModal');
  if (!modal) return;

  function normalizeStates(input) {
    var list = Array.isArray(input) ? input : String(input || '').split(/[\s,]+/);
    return list
      .map(function (code) {
        return String(code || '').trim().toUpperCase();
      })
      .filter(function (code) {
        return /^[A-Z]{2}$/.test(code);
      });
  }

  function showModal() {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('state-restrictions-open');
    document.body.classList.add('state-restrictions-open');
  }

  function hideModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('state-restrictions-open');
    document.body.classList.remove('state-restrictions-open');
  }

  function hasSeenNotice() {
    try {
      return sessionStorage.getItem(SESSION_SEEN_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markNoticeSeen() {
    try {
      sessionStorage.setItem(SESSION_SEEN_KEY, '1');
    } catch (e) {}
  }

  function showNoticeOnce() {
    if (hasSeenNotice()) return;
    markNoticeSeen();
    showModal();
  }

  function isRestrictedState(regionCode, countryCode) {
    if (String(countryCode || '').toUpperCase() !== 'US') return false;
    if (!restrictedStates.length) return false;
    return restrictedStates.indexOf(String(regionCode || '').toUpperCase()) !== -1;
  }

  function getCachedGeo() {
    if (!useGeoCache) {
      return null;
    }
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts || !parsed.data) return null;

      if (parsed.apiUrl && parsed.apiUrl !== geoApiUrl) {
        return null;
      }

      if (Date.now() - parsed.ts > STORAGE_TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function setCachedGeo(data) {
    if (!useGeoCache) {
      return;
    }
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          ts: Date.now(),
          data: data,
          apiUrl: geoApiUrl,
        })
      );
    } catch (e) {}
  }

  async function fetchGeo() {
    var cached = getCachedGeo();
    if (cached) return cached;

    var response = await fetch(geoApiUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Geo lookup failed with status ' + response.status);
    }

    var data = await response.json();
    setCachedGeo(data);
    return data;
  }

  function bindModalClose() {
    modal.addEventListener('click', function (e) {
      if (e.target.matches('[data-state-restrictions-close]')) {
        hideModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        hideModal();
      }
    });
  }

  async function init() {
    bindModalClose();

    try {
      var geo = await fetchGeo();
      var countryCode = geo && (geo.country_code || geo.country);
      var regionCode = geo && (geo.region_code || geo.region);

      if (isRestrictedState(regionCode, countryCode)) {
        showNoticeOnce();
      }
    } catch (err) {
      console.warn('[StateRestrictions]', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
